<template>
  <transition name="slideout">
    <div
      v-if="slideoutOpen"
      class="product-slideout-wrapper"
      data-close
      @click="closeSlideout($event)"
    >
      <div class="product-slideout">
        <div class="product-slideout__header flex items-center justify-between">
          <h2 class="h5">
            {{ title }}
          </h2>

          <button
            class="close-btn xs font-semibold flex items-center"
            data-close
            @click="closeSlideout($event)"
          >
            Close
            <CloseIcon />
          </button>
        </div>

        <template v-if="!isCombinedListingsProduct">
          <div class="product-slideout__grid grid grid-cols-3 overflow-auto text-center">
            <button
              v-for="product in variantCollectionProducts"
              :key="product.handle"
              class="product-slideout__grid-item"
              :class="{
                'product-slideout__grid-item--active': product.handle === currentProductHandle,
                'product-slideout__grid-item--oos': product.inventoryQuantity <= 0
              }"
              @click="updateProduct(product)"
            >
              <div
                class="product-slideout__grid-item-image"
                :class="{ 'product-slideout__grid-item-image--png': product.image.includes('.png') }"
              >
                <img
                  v-lazy="product.image"
                  :alt="product.handle"
                >
              </div>
              <h3 class="xs">
                {{ product.title.split(' / ')[0] }}
              </h3>
            </button>
          </div>
        </template>
        <template v-else>
          <div class="product-slideout__grid grid grid-cols-3 overflow-auto text-center">
            <button
              v-for="variant in product.variants"
              :key="variant.id"
              class="product-slideout__grid-item"
              :class="{
                'product-slideout__grid-item--active': variant.id === selectedVariant.id,
                'product-slideout__grid-item--oos': !variant.available
              }"
              @click="updateVariant(variant)"
            >
              <div
                class="product-slideout__grid-item-image"
                :class="{ 'product-slideout__grid-item-image--png': variant.featured_image.includes('.png') }"
              >
                <img
                  v-lazy="variant.featured_image"
                  :alt="variant.handle"
                >
              </div>
              <h3 class="xs">
                {{ variant.title.split(' / ')[0] }}
              </h3>
            </button>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import { useVariantCollectionStore } from '../../pinia/VariantCollectionStore'
import { useProductStore } from '../../pinia/ProductStore'
import { mapState, mapActions } from 'pinia'

import CloseIcon from '../../icons/close-icon'

export default {
  components: {
    CloseIcon
  },
  props: {
    title: {
      type: String,
      default: null
    },
    variantCollectionProducts: {
      type: Array,
      default: null
    },
    isCombinedListingsProduct: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useVariantCollectionStore, ['slideoutOpen']),
    ...mapState(useProductStore, ['product', 'selectedVariant']),
    currentProductHandle () {
      return this.product.handle
    }
  },
  methods: {
    ...mapActions(useVariantCollectionStore, [
      'closeSlideout'
    ]),
    ...mapActions(useProductStore, [
      'changeProductByHandle',
      'changeSelectedVariant'
    ]),
    async updateProduct ({ handle, metafields, inventoryQuantity }) {
      if (handle !== this.currenProductHandle) {
        await this.changeProductByHandle({ handle, metafields, inventoryQuantity })
        this.closeSlideout()
      }
    },
    async updateVariant (variant) {
      if (variant.id !== this.selectedVariant.id) {
        await this.changeSelectedVariant(variant.id)
        this.closeSlideout()
      }
    }
  }
}
</script>
